import { z } from 'zod';

import { getSkusDuplicateMessage, VALIDATION_MESSAGES } from '~/constants/equipment';

export const moduleSchema = z.object({
  brand: z.string({
    invalid_type_error: VALIDATION_MESSAGES.BRAND_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.BRAND_REQUIRED,
  })
    .trim()
    .max(100, VALIDATION_MESSAGES.BRAND_MAX_LENGTH)
    .min(1, VALIDATION_MESSAGES.BRAND_REQUIRED),

  is_enabled: z.boolean({
    invalid_type_error: VALIDATION_MESSAGES.STATUS_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.STATUS_REQUIRED,
  }),

  model: z.string({
    invalid_type_error: VALIDATION_MESSAGES.MODEL_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.MODEL_REQUIRED,
  })
    .trim()
    .max(100, VALIDATION_MESSAGES.MODEL_MAX_LENGTH)
    .min(1, VALIDATION_MESSAGES.MODEL_REQUIRED),

  power: z.number({
    invalid_type_error: VALIDATION_MESSAGES.POWER_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.POWER_REQUIRED,
  })
    .min(0.1, VALIDATION_MESSAGES.POWER_MIN)
    .max(999, VALIDATION_MESSAGES.POWER_MAX),

  skus: z.array(z.string().trim().min(1)).nullable().optional()
    .refine(
      (value) => {
        if (!value?.length) return true;
        return new Set(value).size === value.length;
      },
      (value) => {
        const duplicate = value?.find((sku, index) => value.indexOf(sku) !== index);
        return { message: duplicate ? getSkusDuplicateMessage(duplicate) : '' };
      },
    ),
});

export type ModuleFormData = z.infer<typeof moduleSchema>;

export const updateModuleSchema = moduleSchema.partial();

export type UpdateModuleFormData = z.infer<typeof updateModuleSchema>;
